import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert/alert.component';
import { LoaderComponent } from './loader/loader.component';
import { BasePinInputComponent } from './base-pin-input/base-pin-input.component';
import { BaseCardComponent } from './base-card/base-card.component';
import { AuthHeaderComponent } from './auth-header/auth-header.component';
import { HeaderComponent } from './header/header.component';
import { BaseButtonComponent } from './base-button/base-button.component';
import { RouterModule } from '@angular/router';
import { OrderCardComponent } from './order-card/order-card.component';
import { DateagoPipe } from 'src/services/pipes/dateago/dateago.pipe';
import { BaseTableComponent } from './base-table/base-table.component';
import { MatTableModule } from '@angular/material/table';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { DrawerComponent } from './drawer/drawer.component';
import { MenuDrawerComponent } from './menu-drawer/menu-drawer.component';

@NgModule({
  declarations: [
    AlertComponent,
    LoaderComponent,
    BasePinInputComponent,
    BaseCardComponent,
    AuthHeaderComponent,
    HeaderComponent,
    BaseButtonComponent,
    OrderCardComponent,
    BaseTableComponent,
    OrderDetailsComponent,
    DrawerComponent,
    MenuDrawerComponent,
  ],
  imports: [
    DateagoPipe,
    CommonModule,
    FormsModule,
    RouterModule,
    MatSlideToggleModule,
    MatTableModule,
  ],
  exports: [
    AlertComponent,
    LoaderComponent,
    BasePinInputComponent,
    BaseCardComponent,
    AuthHeaderComponent,
    HeaderComponent,
    BaseButtonComponent,
    MatSlideToggleModule,
    OrderCardComponent,
    DateagoPipe,
    BaseTableComponent,
    OrderDetailsComponent,
    DrawerComponent,
    MenuDrawerComponent
  ],
})
export class SharedModule {}
